/**
 * Timeline Module.
 *
 * This will handle any bound events and callbacks
 * for load more buttons throughout the site.
 *
 * This will be loaded with the the namespace: loadMore.
 *
 * This will be initialized with timeline.init();
 *
 * @param data
 * @returns {boolean}
 */

/**
 * Require jQuery.
 */
var $ = require('jquery');
var rest = require('./rest');

/**
 * Fetch callback.
 *
 * Process to update the DOM with the rest call results.
 *
 * 1. Get the data json object
 * 2. Remove the fetch class and unbind the rest call on event.
 * 3. Append markup to the results element.
 * 4. Update the button loading text with the initial text.
 *
 * @param data The json object from the rest call.
 *
 */
var fetchCallback = function (data) {

    $('.timeline ' + data.query.domID + '.fetch').off();
    $(data.query.domID).toggleClass("fetch");
    $(data.query.domID).toggleClass("fetched");

    if ( "day" === data.query.grouping ) {
        $(data.query.domID).parent().after(data.markup);
        completedState($(data.query.domID).find('span'), data.query.initialText);
    }

    if ( "month" === data.query.grouping ) {
        $(data.query.domID + ' .timeline-panel').toggleClass('collapsed');
        $(data.query.domID + ' .timeline-panel').append(data.markup);
        completedState($(data.query.domID + ' .timeline-badge.point > span'), data.query.initialText);
    }

    /**
     * This is to make sure that the appended
     * items do not show when clicking the
     * parent year if they were not already
     * visible.
     */
    $('.archive-month-header > .archive-year').click(function () {

        var archive_class = $(this).data('target');

        $('.timeline').find('li[data-yearclass="' + archive_class + '"]').each(function () {
            if('true' === $(this).prevAll('.archive-year-month-header:first').attr('aria-expanded')) {
                $(this).collapse("hide");
            }
        });

    });
};

/**
 * Timeline fetch load more event for authors.
 *
 * This will trigger a derived load more rest call by:
 *
 * 1. Attach a click event to any element with
 * the class: ".fetch"
 *
 * 2. Get the current load more button text.
 *
 * 3. Set the loading text.
 *
 * 4. Set the data-query to a query variable so
 * we can alter it.
 *
 * 5. Add a query.domID property with the id of the
 * parent element which will have the results appended.
 *
 * 6. Add a query.initialText to hold the initial text
 * of the title so we can rest in in the callback.
 *
 * 7. Make the rest call.
 *
 */
var authorfetch = function () {
    $('.editor-details .timeline .fetch').click(function () {

        var $header = $(this).find("span").first();
        var query = $(this).data('query');
        var initial_text = $header.text();

        query.domID = '#' + $(this).attr('id');
        query.initialText = initial_text;

        loadingState($header, 'Loading...');

        rest.postJson('/wp-json/ir/v1/post/author-timeline-archive/', query, fetchCallback);

    });
};

/**
 * Timeline fetch load more event for companies.
 *
 * Same pattern as the authors timeline.
 *
 * @todo
 * This could be refactored by passing the rest url
 * in a data attribute.
 *
 */
var companyfetch = function () {
    $('.company .timeline .fetch').click(function () {

        var $header = $(this).find("span").first();
        var query = $(this).data('query');
        var initial_text = $header.text();

        query.domID = '#' + $(this).attr('id');
        query.initialText = initial_text;

        loadingState($header, 'Loading...');

        rest.postJson('/wp-json/ir/v1/post/company-timeline-archive/', query, fetchCallback);

    });
};

/**
 * Update DOM while the rest call is happening.
 *
 * @param elem
 * @param loading_text
 */
var loadingState = function (elem, loading_text) {
    elem.text(loading_text);
};

/**
 * Update DOM when the rest call completes.
 *
 * This is meant to be called from the callback.
 *
 * @param elem
 * @param initial_text
 */
var completedState = function (elem, initial_text) {
    elem.text(initial_text);
};

/**
 * Methods to execute immediately.
 */
var init = function () {
    authorfetch();
    companyfetch();
};

/**
 * Export all of the methods.
 */
module.exports = {
    init: init,
    fetchCallback: fetchCallback,
    loadingState: loadingState,
    completedState: completedState
};
